module.exports = __webpack_public_path__ + "img/457.6d0bf318.png";